import { useEffect } from 'react';

import { getProductView_productDetailByMasterId } from '@containers/ProductDetailContainer/queries/__generated__/getProductView';
import { EXCLUDE_FROM_LAST_VISITED } from '@utils/constants';
import { requestIdleCallback } from '@utils/requestIdleCallback';

import { appendProductToCookie } from './utils';

type IUseAddToLastVisited = Pick<
  getProductView_productDetailByMasterId,
  'variants' | 'id'
>;

export const useAddToLastVisited = ({ id, variants }: IUseAddToLastVisited) => {
  useEffect(() => {
    requestIdleCallback(() => {
      const canBuy = variants.some((variant) => variant.canBuy === true);

      const canSaveToLastVisited = variants.every(
        (variant) =>
          !variant.navigationValues.includes(EXCLUDE_FROM_LAST_VISITED)
      );
      if (canBuy && canSaveToLastVisited) {
        appendProductToCookie(id);
      }
    });
  }, [id, variants]);
};
